import { LanguageCode } from '../models/language-code';

/**
 * Flatmaps supported languages from a list of objects containing such field (various case models).
 * @param cases a list of objects containing supported languages
 * @return a list of unique language codes
 */
export function getSupportedLanguages(
    cases: { supportedLanguages: string[] }[]
): LanguageCode[] {
    return [
        ...new Set(
            cases.flatMap((c) => c.supportedLanguages as LanguageCode[])
        ),
    ];
}
